import { render, staticRenderFns } from "./ActiveUser.vue?vue&type=template&id=48611a2f&scoped=true&"
import script from "./ActiveUser.vue?vue&type=script&lang=js&"
export * from "./ActiveUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48611a2f",
  null
  
)

export default component.exports